import sortOptions from "./options";

const DEFAULT_SORT = sortOptions.FEATURED_NEW_TOP;

export default DEFAULT_SORT;
